import {
  PagingInfo,
} from "@elastic/react-search-ui";

import { SORT_OPTIONS } from './sortOptions';

import mapLinkClick from "lib/ga/mapClick"
import styles from './search.module.css';

import Pagination from "./Pagination";
import ResultsTotal from "./ResultsTotal";
import Sort from "./Sort";



export const PaginationBar = ({ locationDetails, showMap, totalPages, onShowMap, currentPage, setCurrentPage, ...props }) => {
  const viewIcon = `${showMap ? 'list' : 'map'}-view.svg`;
  const showMapMethod = () => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());

    if ('map' in params) {
      delete params['map'];
    } else {
      params['map'] = 'true';
    }

    let data = {
      ...params
    }

    let convert = new URLSearchParams(data).toString()
    const newPath = `${window.location.pathname}?${convert}`;
    window.history.replaceState({ ...window.history.state, as: newPath, url: newPath }, '', newPath)
  }

  return (
    <div className={totalPages >  1 ? styles.resultsHeader : styles.resultsHeaderNoPagination}> 
      <Pagination currentPage={currentPage} setCurrentPage={setCurrentPage} />
      <PagingInfo
        view={({ start, end, totalResults }: { start: number, end: number, totalResults: number }) => (
          <ResultsTotal start={start} end={end} location={locationDetails} totalResults={totalResults} where={"top"} />
        )}
      />
      <div className={styles.mapButton}>
        <button className={styles.buttonTopBar}
          // className={showMap ? 'active' : ''}
          onClick={(e) => {
            onShowMap(!showMap)
            mapLinkClick();
            showMapMethod();
          }}
        >
          <picture>
            <source media="(prefers-color-scheme: dark)" srcSet={`${process.env.NEXT_PUBLIC_APP_CDN_URL}icons/dark/${viewIcon}`} />
            <img className="light" alt="Map view" src={`${process.env.NEXT_PUBLIC_APP_CDN_URL}icons/${viewIcon}`} width="20" height="20" />
          </picture>
          {showMap ? 'List view' : 'Map view'}
        </button>
      </div>
      <Sort sortOptions={SORT_OPTIONS} defaultSortOrder={props.defaultSortOrder} />
    </div>

  )
}
